module.exports = __webpack_public_path__ + "img/americanfootball-dark.3da74d32.svg";